export const SET_TRIGGERED_ALARMS = "SET_TRIGGERED_ALARMS";
export const HIDE_TOAST_MESSAGE = "HIDE_TOAST_MESSAGE";
export const SET_AVAILABLE_ASSETS = "SET_AVAILABLE_ASSETS";
export const SHOW_ERROR_MESSAGE = "SHOW_ERROR_MESSAGE";
export const SHOW_SUCCESS_MESSAGE = "SHOW_SUCCESS_MESSAGE";
export const RESET_STATE = "RESET_STATE";
export const GET = "GET";
export const LOAD_METADATA = "LOAD_METADATA";
export const CLEAR_SELECTED_ASSETS = "CLEAR_SELECTED_ASSETS";
export const CLEAR_SELECTED_STATUSES = "CLEAR_SELECTED_STATUSES";
export const SET_SEARCH = "SET_SEARCH";
export const TOGGLE_SELECT_ALL_ASSETS = "TOGGLE_SELECT_ALL_ASSETS";
export const TOGGLE_SELECT_ALL_STATUSES = "TOGGLE_SELECT_ALL_STATUSES";
export const CLEAR_FILTERS = "CLEAR_FILTERS";

